import React from 'react'
import Loader from '../loaders/dot-loader'

const LoaderModal = () => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
            <Loader />
        </div>
    )
}

export default LoaderModal